export default __webpack_public_path__ + "static/media/IMG_007.2e6645c5.jpg";